module.exports = __webpack_public_path__ + "static/apexpr-logo-e2893c256b48e60311d1c7d93ed82608.png";